// import {
//   ADD_PROGRAM,
//   DELETE_ADD_PROGRAM,
//   PROGRAM_HISTORY,
// } from "../../Action/Sizer/sendYarn";
import { DELETE_ADD_PROGRAM, ADD_PROGRAM, PROGRAM_HISTORY } from "../../Types";

const initialState = {
  addProgram: [],
};

function addPproprogram(state = initialState, action) {
  switch (action.type) {
    case ADD_PROGRAM: {
      return { ...state, addProgram: [action.payload, ...state.addProgram] };
    }

    case DELETE_ADD_PROGRAM: {
      const afterDeleteProgram = state.addProgram.filter(
        (addProgram) =>
          addProgram.add_program_id !== action.payload.add_program_id
      );
      return { ...state, addProgram: afterDeleteProgram };
    }
    case PROGRAM_HISTORY: {
      return { ...state, addProgram: action.payload };
    }
    default:
      return state;
  }
}

export default addPproprogram;
